import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { snackInfo } from 'app/core/config/snackbar.config';
import { launchForte } from 'app/utils/forte';
import { Observable, combineLatest, filter, tap, distinctUntilChanged } from 'rxjs';
import * as PricingActions from 'app/store/pricing/pricing.actions';
import * as PricingSelectors from 'app/store/pricing/pricing.selectors';
import { PaymentService } from 'app/core/services/payment.service';
import {HttpClient} from "@angular/common/http";
import {AuthNewService} from "../../core/auth/auth.new.service";
@Component({
	selector: 'app-pricing-modal',
	templateUrl: './pricing-modal.component.html',
	styleUrls: ['./pricing-modal.component.scss'],
})
export class PricingModalComponent implements OnInit {
	showPricingModal$: Observable<boolean> = this.store.select(PricingSelectors.selectShowPricingModal);
	developerPlanId: string;

	constructor(
		private store: Store,
		private snackBar: MatSnackBar,
		private paymentService: PaymentService,
		private http: HttpClient,
		private readonly _authNewService: AuthNewService
	) {}

	ngOnInit(): void {
		this.store.dispatch(PricingActions.loadPricingInfo());

		combineLatest([this.store.select(PricingSelectors.selectDeveloperPlanId), this.store.select(PricingSelectors.selectPricingLoading)])
			.pipe(
				filter(([_, loading]) => !loading),
				tap(([planId, _]) => {
					if (planId) {
						this.developerPlanId = planId;
						this.store.dispatch(PricingActions.togglePricingModal({ show: false }));
						document.body.style.overflow = 'auto';
					} else {
						this.store.dispatch(PricingActions.togglePricingModal({ show: true }));
						document.body.style.overflow = 'hidden';
					}
				}),
			)
			.subscribe();
	}

	async choosePlan(plan: string): Promise<void> {
		switch (plan) {
			case 'pro':
				this.store.dispatch(PricingActions.setPlan({ planId: plan }));
				this.snackBar.open('Your Pro Plan request has been submitted. A member of our team will be in touch soon!', 'Understood', snackInfo);
				break;
			case 'studio':
				this.http.post<{ url: string }>('https://create-stripe-checkout-session-437015368852.us-central1.run.app', {
					priceId: 'price_1RdiLAQKoa47a31HMNStQ0xe',
					successUrl: window.location.origin + '/success',
					cancelUrl: window.location.origin + '/cancel',
					metadata: {
						userId: this._authNewService.getUserData().userId,
						plan: 'studio'
					}
				}).subscribe(res => {
					window.location.href = res.url;
				});
				break;
			case 'studio_old':
				this.paymentService
					.createPaymentIntent(plan)
					.pipe(
						tap(({ data }) => {
							if (data) {
								const planSuccessHandler = async () => {
									this.store.dispatch(PricingActions.setPlan({ planId: plan }));
									this.store.dispatch(PricingActions.togglePricingModal({ show: false }));
									document.body.style.overflow = 'auto';
									window.removeEventListener('FortePaymentsBuyVdaSuccess', planSuccessHandler);
									window.removeEventListener('FortePaymentsWidgetClosed', planCancelHandler);
								};

								const planCancelHandler = () => {
									window.removeEventListener('FortePaymentsBuyVdaSuccess', planSuccessHandler);
									window.removeEventListener('FortePaymentsWidgetClosed', planCancelHandler);
								};

								window.addEventListener('FortePaymentsBuyVdaSuccess', planSuccessHandler);
								window.addEventListener('FortePaymentsWidgetClosed', planCancelHandler);

								launchForte(data);
							}
						}),
					)
					.subscribe();
				return;

			default:
				this.store.dispatch(PricingActions.setPlan({ planId: plan }));
				break;
		}
		this.store.dispatch(PricingActions.togglePricingModal({ show: false }));
		document.body.style.overflow = 'auto';
	}

	skipPricing() {
		if (!this.developerPlanId) {
			this.store.dispatch(PricingActions.setPlan({ planId: 'starter' }));
		}
		this.store.dispatch(PricingActions.togglePricingModal({ show: false }));
		document.body.style.overflow = 'auto';
	}
}
